/* eslint-disable react-native/no-inline-styles */
import {useIsFocused} from '@react-navigation/native';
import {
  Avatar,
  IndexPath,
  Layout,
  Select,
  SelectItem,
  Text,
} from '@ui-kitten/components';
import React, {useEffect, useState} from 'react';
import {Platform, StyleSheet, View} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import {getImage} from '../../../helpers/general';
import {
  getAndSetCheckAnnouncement,
  getAndSetProfile,
} from '../../../redux/actions';
import {
  getAndSetAllGrades,
  getAndSetAllKids,
  getAndSetAllPackages,
  getAndSetAllSubjects,
} from '../../../redux/actions/general';
import {px, useAsync, useIsLandscape, wp} from '../../../utils';
import {Page} from '../../components';
import FilterModal from './components/FilterModal';
import NewNotifModal from './components/NewNotifModal';
import PlanCards from './components/PlanCards';
import TelegramGroupsCard from './components/TelegramGroupsCard';

const Home = () => {
  const dispatch = useDispatch();
  const isFocused = useIsFocused();
  const isLandscape = useIsLandscape();
  const [isFilterModalVisible, setIsFilterModalVisible] = useState(false);
  const [showNewNotifModal, setShowNewNotifModal] = useState(false);
  const [kidIndex, setKidIndex] = useState(new IndexPath(0));

  const haveNewNotif = useSelector((state) => state.inbox.haveNewNotif);
  const kids = useSelector((state) => state.general.kids);
  const user = useSelector((state) => state.auth.user);

  const selectedStudent = kids?.find(
    (_, rowIndex) => rowIndex === kidIndex.row,
  );

  useAsync(() => dispatch(getAndSetAllPackages()), [isFocused]);
  useAsync(() => dispatch(getAndSetAllSubjects()), [isFocused]);
  useAsync(() => dispatch(getAndSetAllGrades()));
  useAsync(() => dispatch(getAndSetAllKids()), [isFocused]);
  useAsync(() => dispatch(getAndSetProfile()), [isFocused]);
  useAsync(() => dispatch(getAndSetCheckAnnouncement()));

  useEffect(() => {
    if (isFocused && haveNewNotif) {
      setShowNewNotifModal(true);
    }
  }, [isFocused, haveNewNotif]);

  return (
    <>
      <Page
        header={{
          title: isLandscape ? 'Home' : 'Welcome Star Student!',
          showDrawerAction: true,
        }}
        scrollViewStyle={[
          styles.scrollView,
          isLandscape ? {paddingHorizontal: wp(20)} : undefined,
        ]}>
        {user.userType === 'parent' && (
          <Select
            status="primary"
            style={styles.selectKid}
            value={selectedStudent?.name}
            selectedIndex={kidIndex}
            onSelect={setKidIndex}>
            {kids.map(({name}, itemIndex) => (
              <SelectItem title={name} key={itemIndex} />
            ))}
          </Select>
        )}
        <View style={styles.pageContainer}>
          <Layout style={styles.profileContainer}>
            {kids?.[0]?.kidsImage && (
              <Avatar
                style={styles.avatar}
                source={{
                  uri: kids?.[0]?.kidsImage ? getImage(kids[0].kidsImage) : '',
                }}
              />
            )}
            <Text category="h6" style={{fontWeight: '700'}}>
              {user?.fullName || ''}
            </Text>
            <Text category="h6" style={{fontWeight: '500', marginTop: 5}}>
              {user?.gradeName || ''}
            </Text>
          </Layout>
          <PlanCards />
          <TelegramGroupsCard user={user} />
        </View>
      </Page>
      <FilterModal
        visible={isFilterModalVisible}
        onClose={() => setIsFilterModalVisible(false)}
      />
      <NewNotifModal
        visible={showNewNotifModal}
        onClose={() => setShowNewNotifModal(false)}
      />
    </>
  );
};

const styles = StyleSheet.create({
  scrollView: {
    height: Platform.OS === 'web' ? '75vh' : 'auto',
  },
  pageContainer: {
    width: px(400),
    alignSelf: 'center',
  },
  headerIconsContainer: {
    flexDirection: 'row',
    backgroundColor: 'transparent',
  },
  headerIcon: {
    width: px(30),
    height: px(30),
    marginLeft: px(10),
  },
  selectKid: {
    marginHorizontal: px(17),
    marginTop: px(17),
  },
  profileContainer: {
    marginVertical: 16,
    alignItems: 'center',
  },
  avatar: {
    width: px(76),
    height: px(76),
    backgroundColor: '#FFEDEF',
    marginBottom: 8,
  },
});

export default Home;
